import { FormEvent } from 'react'
import { useObjectActionMutation } from '../api/object'
import { Button } from '../components/button'
import { Dialog } from '../components/dialog'
import { Switch } from '../components/switch'

export function Alternative({ onClose, proposalId }: { onClose: () => void; proposalId: string }) {
	const { mutate: sendAlternative, isPending: isSendingAlternative } = useObjectActionMutation(
		'proposal',
		proposalId,
		'send-alternative',
	)

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault()
		sendAlternative(new FormData(event.currentTarget), {
			onSuccess() {
				onClose()
			},
		})
	}

	return (
		<Dialog heading="Odeslat alternativní nabídku" isOpen onOpenChange={onClose}>
			<form className="m-4 space-y-4" onSubmit={onSubmit}>
				<Switch
					label="Odeslat e-mailem"
					name="sendEmail"
					defaultSelected={true}
					value="1"
				/>
				<Button type="submit" variant="PRIMARY" isPending={isSendingAlternative}>
					Odeslat
				</Button>
			</form>
		</Dialog>
	)
}
